<template>
  <van-dialog
    theme="round-button"
    class="custom-dialog"
    v-model="show"
    :title="data.title"
    :show-confirm-button="data.showConfirmButton"
    :show-cancel-button="data.showCancelButton"
    :confirm-button-text="confirmButtonText"
    :cancel-button-text="data.cancelButtonText"
    :before-close="beforeClose"
  >
    <div class="dialog-content">
      <div v-if="data.confirmObj">
        <van-row
          v-for="(item, index) in data.confirmObj"
          :key="index"
        >
          <van-col
            span="12"
            :class="{ space: item.space }"
          >{{
            item.key
          }}</van-col>
          <van-col
            span="12"
            :class="{ space: item.space }"
          >{{
            item.value
          }}</van-col>
        </van-row>
      </div>

      <div v-if="data.confirmObj2">
        <div
          v-for="(item, index) in data.confirmObj2"
          :key="index"
          class="item"
        >
          <span>{{ item.key }}</span>
          <span class="color-red">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
const initData = () => {
  return {
    title: '是否确认更新数据？',
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: '返回修改',
    confirmButtonText: '继续提交',
    confirmText: null,
    confirmObj: null,
    confirmObj2: null
  };
};
export default {
  name: 'AddValueProductDialog',
  data() {
    return {
      show: false,
      data: initData(),
      timer: null,
      counter: 3,
      confirmButtonText: '继续提交（3）',
      canClose: false
    };
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    open(data) {
      this.data = initData();
      data && (this.data = { ...this.data, ...data });
      console.log('this.data', this.data);
      this.counter = 3;
      this.show = true;
      this.initTimer();
    },
    close() {
      this.show = false;
    },
    beforeClose: function(action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === 'confirm') {
        if (this.canClose) {
          console.log('-----confirm-----', this.canClose);
          this.confirm();
          done(); // 关闭提示框
        } else {
          done(false); // 阻止关闭弹框
        }
      } else if (action === 'cancel') {
        done(); // 关闭提示框
      }
    },
    confirm() {
      this.close();
      this.data.confirmCallback && this.data.confirmCallback.apply(this);
    },
    cancel() {
      this.close();
      this.data.cancelCallback && this.data.cancelCallback.apply(this);
    },
    dealButtonText() {
      if (this.counter > 0) {
        this.confirmButtonText = `继续提交（${this.counter}）`;
        this.counter--;
        this.canClose = false;
      } else {
        this.confirmButtonText = `继续提交`;
        this.canClose = true;
        this.clearTimer();
      }
      console.log('dealButtonText2', this.confirmButtonText, this.counter);
    },
    initTimer() {
      if (this.timer) {
        return;
      }
      this.dealButtonText();
      this.timer = setInterval(this.dealButtonText, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog {
  &.van-dialog ::v-deep {
    .van-dialog__header {
      padding: 14px 0;

      text-align: center;

      color: #383838;
      border-radius: 8px 8px 0px 0px;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);

      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: 400;
    }
    .van-dialog__content {
      .dialog-content {
        padding: 8px 24px 24px;

        text-align: center;
        letter-spacing: -0.41px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .item {
          display: flex;
          flex-direction: row;
          font-size: 24px;
          color: #383838;
          margin-top: 24px;
          font-weight: bold;
          align-items: center;
          .color-red {
            color: #f32222;
            margin-left: 4px;
          }
        }

        .content-text {
          padding: 16px 4px 0;
          overflow-y: auto;

          max-height: 120px;
        }

        .van-row {
          .van-row {
            padding-top: 16px;
          }
          .van-col {
            text-align: left;
            & + .van-col {
              text-align: right;

              color: #383838;

              font-family: PingFangSC-Medium;
              font-weight: 500;
            }
          }
        }
      }
    }
    .space {
      margin-top: 24px;
    }
    .van-dialog__footer {
      padding: 0 24px 24px;
      .van-button {
        height: 40px;

        text-align: center;
        letter-spacing: -0.41px;

        & + .van-button {
          margin-left: 17px;
        }
        &.van-dialog__cancel {
          color: #646464;
          border-radius: 8px;
          background: #edf2f7;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
        &.van-dialog__confirm {
          color: #ffffff;
          border-radius: 8px;
          background: #3399ff;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
